import {i18n} from "./../../../plugins/vue-i18n";

const validateLatinName = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateLatinName")
};

function validate(input) {
  return /^[A-Za-z\s\-!?"'><№#@$^:.,*)(\d]*$/.test(input);
}

export default validateLatinName;
